ScoreTrekBattle.Tournament.Series.List = (function() {
    var _this, CONFIG, STATUS, CACHE;

    CONFIG = {
        CACHE_SIZE: 5,
        FOCUS_DELAY: 400
    };

    CACHE = ListState.create(CONFIG.CACHE_SIZE);

    function resetStatus() {
        STATUS = {
            active: false,
            loaded: false,
            $view: null,
            $list: null,
            isClub: false,
            clubId: null,
            focusSeriesId: null,
            isShown: false,
            renderId: 0,
            CURRENT: null
        };

        ScoreTrekBattle.Club.setCurrent(null);
    }
    resetStatus();

    function onViewRender(clubId) {
        return new Promise(function(resolve, reject) {
            if (clubId) {
                STATUS.isClub = true;
                STATUS.clubId = clubId;
            }
            ScoreTrekBattle.View.updateMenu('/series/list');
            ScoreTrekBattle.Template.render('tournament/series/list', {
                mode: STATUS.isClub ? 'club' : 'list',
                clubId: STATUS.clubId || ''
            }).then(view => {
                STATUS.active = true;
                STATUS.$view = view.$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');
                STATUS.$view.find('[data-ref-id="seriesPlan"]').remove();
                resolve(STATUS.$view);
            });
        });
    }

    function getFocusSeriesId(seriesId) {
        return STATUS.isClub ? '' : seriesId;
    }

    function onViewLoad(seriesId) {
        return new Promise(function(resolve) {
            STATUS.active = true;
            updateClub().then(() => {
                updateList(getFocusSeriesId(seriesId));
            }).catch(ignore => {}).finally(() => {
                resolve();
            });
        });
    }

    function onViewUpdate(seriesId) {
        return new Promise(function(resolve) {
            setTimeout(() => {
                if (!STATUS.$list) {
                    return;
                }
                updateList(getFocusSeriesId(seriesId));
            }, 0);
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            if (STATUS.CURRENT) {
                STATUS.CURRENT.scrollTop = AnimationHandler.getScrollTop();
            }

            resetStatus();
            resolve();
        });
    }

    function getCacheKey() {
        return STATUS.isClub ? `club:${STATUS.clubId}` : 'list';
    }

    function updateClub() {
        return new Promise(function(resolve, reject) {
            if (!STATUS.clubId) {
                STATUS.$view.find('[data-ref-id="club"]').remove();
                resolve();
                return;
            }

            STATUS.$view.find('[data-tab="series"]').addClass('isActive');

            ScoreTrekBattle.View.loading('Tournament.Series.List.updateClub', true);

            ScoreTrekBattle.Club.load(STATUS.clubId).then(club => {
                ScoreTrekBattle.Club.setCurrent(club);

                ScoreTrekBattle.Template.render('tournament/details/club', {
                    club: club,
                    clubEscaped: ScoreTrekBattle.Club.escape(club),
                    mapsUrl: ScoreTrekBattle.Club.getMapsUrl(club)
                }).then(view => {
                    STATUS.$view.attr({
                        'data-club-id': club.id,
                        'data-club-is-favorite': club.isFavorite ? 'yes' : 'no'
                    });

                    STATUS.$view.find('[data-tab="tournament"]').attr('href', `/club/tournaments/${club.id}`);
                    STATUS.$view.find('[data-tab="tournaments"]').attr('href', `/club/tournaments/${club.id}`);
                    STATUS.$view.find('[data-tab="series"]').attr('href', `/club/series/${club.id}`);
                    STATUS.$view.find('[data-tab="matchdays"]').attr('href', `/club/matchdays/${club.id}`);

                    STATUS.$view.find('[data-id="clubDetails"]').append(view.$view);

                    ['email', 'phone', 'website'].forEach(field => {
                        if (!club[field]) {
                            STATUS.$view.find(`[data-id="club.${field}"]`).remove();
                        }
                    });

                    STATUS.$view.find('[data-id="club.hiddenTournaments"]').remove();

                    resolve();
                });
            }).catch(error => {
                ScoreTrekBattle.View.goto('/dashboard').then(() => {
                    setTimeout(() => {
                        chmDialog.error(error);
                    }, 0);
                });
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Series.List.updateClub', false);
            });
        });
    }

    function updateList(seriesId) {
        let cacheItem, hasCache, loadingId;

        cacheItem = CACHE.get(getCacheKey());

        if (STATUS.loaded) {
            cacheItem.scrollTop = AnimationHandler.getScrollTop();
        }

        STATUS.CURRENT = cacheItem;
        STATUS.isShown = false;
        hasCache = Array.isArray(cacheItem.items);
        loadingId = 'Tournament.Series.List.updateList';

        if (hasCache) {
            renderList(cacheItem.items).then(isRendered => {
                if (isRendered && !STATUS.isShown) {
                    showList(seriesId, cacheItem.scrollTop);
                }
            });
        }

        ScoreTrekBattle.View[hasCache ? 'loadingBackground' : 'loading'](loadingId, true);

        loadList(hasCache).then(items => {
            if (!STATUS.$list || (STATUS.CURRENT !== cacheItem)) {
                return;
            }

            if (hasCache && ListState.isEqual(items, cacheItem.items)) {
                return;
            }

            cacheItem.items = items;

            return renderList(items).then(isRendered => {
                if (isRendered && !STATUS.isShown) {
                    showList(seriesId, cacheItem.scrollTop);
                }
            });
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View[hasCache ? 'loadingBackground' : 'loading'](loadingId, false);
        });
    }

    function showList(seriesId, scrollTop) {
        let focusSeriesId;

        STATUS.isShown = true;
        focusSeriesId = seriesId || STATUS.focusSeriesId;

        if (!focusSeriesId) {
            STATUS.loaded = true;
            ListState.restoreScrollTop(STATUS.$view, scrollTop);
            return;
        }

        setTimeout(() => {
            if (!STATUS.$view) {
                return;
            }

            STATUS.loaded = true;
            setFocus(focusSeriesId);
        }, CONFIG.FOCUS_DELAY);
    }

    function loadList(isQuiet) {
        return new Promise(function(resolve, reject) {
            if (!isQuiet) {
                STATUS.$list.addClass('loading');
            }

            Api.request('/battle/tournament/series/list', {
                isClub: STATUS.isClub || null,
                clubId: STATUS.isClub ? STATUS.clubId : null,
            }).then(result => {
                resolve(result.list);
            }).catch(reject).finally(() => {
                if (STATUS.$list) {
                    STATUS.$list.removeClass('loading');
                }
            });
        });
    }

    function renderList(items) {
        return new Promise(function(resolve) {
            let promises, renderId;

            renderId = ++STATUS.renderId;
            promises = [];

            items.forEach(item => {
                promises.push(renderItem(item));
            });

            if (promises.length === 0) {
                promises.push(renderItem(null));
            }

            Promise.all(promises).then($items => {
                if (!STATUS.$list || (renderId !== STATUS.renderId)) {
                    resolve(false);
                    return;
                }

                STATUS.$list.empty().append($items);
                resolve(true);
            });
        });
    }

    function renderItem(item) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render(item ? 'tournament/series/listItem' : 'tournament/series/listItemEmpty', {series: item}, true).then(itemView => {
                if (item) {
                    if (item.dateTimeFromDateFormatted === item.dateTimeToDateFormatted) {
                        itemView.$view.find('[data-id="series.to"]').remove();
                    }
                    itemView.$view.find('[data-id="series.tournamentsCountLabel"]').text(__i18n(`tournament/${(item.tournamentsCount === 1) ? 'single' : 'multi'}`));

                }
                resolve(itemView.$view);
            });
        });
    }

    function setFocus(seriesId) {
        STATUS.focusSeriesId = null;
        if (seriesId) {
            AnimationHandler.scrollIntoView(STATUS.$view.find(`[data-series-id="${seriesId}"]`)).then($element => {
                AnimationHandler.pulse($element);
            }).catch(ignore => {});
        }
    }

    _this = {
        renderItem: function(item) {
            return renderItem(item);
        },
        focus: function(seriesId) {
            if (STATUS.loaded) {
                setFocus(seriesId);
            } else {
                STATUS.focusSeriesId = seriesId;
                setTimeout(() => {
                    if (!STATUS.$view) {
                        STATUS.focusSeriesId = null;
                    }
                }, 100);
            }
        }
    };

    ScoreTrekBattle.View.register('/series/list', () => { return onViewRender(); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/club/series', clubId => { return onViewRender(clubId); }, onViewLoad, onViewUpdate, onViewUnload);

    ScoreTrekBattle.Event.on('action.series.click', function(event) {
        let link;

        if (event && $(event.target).closest('a').length > 0) {
            return;
        }

        link = $(this).closest('[data-series-id]').find('a').get(0);

        if (link) {
            ScoreTrekBattle.View.goto(link.pathname + (link.search || ''));
        }
    });

    return _this;
})();